import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import AboutUs from './components/AboutUs'; // About Us page
import ContactUs from './pages/ContactUs'; // About Us page
import Services from './pages/Services'; // About Us page
import Careers from './pages/Careers'; // About Us page
import JobDetails from './pages/JobDetails';
import JobApplication from './pages/JobApplication';
import AdminJobs from './pages/AdminJobs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookieNotification from './components/CookieNotification';
const App = () => {
    return (
        <div className="app-container flex flex-col min-h-screen">
            {/* Header */}
            <Header />
            <CookieNotification />
            {/* Main Content */}
            <main className="flex-1">
                <Routes>
                    {/* Menu Routes */}
                    <Route path="/" element={<LandingPage />} /> {/* Home */}
                    <Route path="/about-us" element={<AboutUs />} /> {/* About Us */}
                    <Route path="/contact-us" element={<ContactUs />} /> {/*  */}
                    <Route path="/services" element={<Services />} /> {/* About Us */}
                    <Route path="/careers" element={<Careers />} /> {/* About Us */}
                    <Route path="/careers/:jobId" element={<JobDetails />} />
                    <Route path="/apply/:jobId" element={<JobApplication />} />
                    <Route path="/admin" element={<AdminJobs />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    {/* Fallback Route */}
                    <Route path="*" element={<div>404 - Page Not Found</div>} />
                </Routes>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default App;